export enum MessageBoxReturnValue {
    ok,
    yes,
    no,
    cancel
}
